// Editorial Warm palette — used by the Nala marketing surface.
// Mirrors the Tailwind `nala` color group so inline-style components and
// utility-class components can both reach the same tokens by name.
//
// Why duplicate? Several editorial pieces (gradients, animated states,
// the BookingModal SVG icons) are easier to express as inline `style`
// objects than as Tailwind classes. Centralizing here means we only
// have to change the brand once.

export const nala = {
  bg:        '#ffffff',
  surface:   '#fbf7ef',
  ink:       '#221d17',
  mute:      '#6e6453',
  line:      '#e6dcc8',
  soft:      '#ede3cf',
  accent:    '#1f3a5f',
  accentInk: '#fbf7ef',
  clay:      '#e8612b',
  footer:    '#3a2f24',
  footerInk: '#e8dcc4',
  footerMute:'#9b8b6e',
  ok:        '#3a8a55',
  radius:    18,
  display:   "'Fraunces', ui-serif, Georgia, serif",
  sans:      "'Inter', ui-sans-serif, system-ui, sans-serif",
} as const

export type NalaPalette = typeof nala
